module.exports = __webpack_public_path__ + "img/3.eaabe8f2.png";